module.exports = __webpack_public_path__ + "img/kl.7efd2348.png";